export default "<p class=\"text-center bg-primary\">\r\n  footer works!\r\n</p>\r\n"